import {Route, useLocation, useNavigate} from 'react-router-dom';
import {useEffect} from 'react';
import DirectoryCategory from '@/app/(main)/directory/category';
import DiscoverCategoryDetail from '@/app/(main)/directory/category/[...categoryParams]';
import CustomRoutes from './CustomRoutes';
import {ROUTE} from '@/constants/main/route';
import useDirectoryStore from '@/stores/directory';
import Directory from '@/app/(main)/directory';

const DirectoryRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // 2차 로그인을 통해 들어올때 탐색쪽 url 구조가 location 의 search 로 파라미터를 받는 구조가 아니라서 토크/캠방 , 먹방/음식 이런류의 카테고리로 진입하면 서브도메인으로 인식하여 기존 라우터 규칙에 맞지않아 에러페이지로 이동해버린다.
    const {pathname} = location;
    if (pathname.includes(ROUTE.DIRECTORY.CATEGORY.INDEX)) {
      const regex = /^\/directory\/category\/([^/]+\/[^/]+)\/(live|vod|catch)$/;
      const match = pathname.match(regex);
      if (match) {
        const modifiedUrl = decodeURIComponent(pathname).match(regex);
        const modifiedCategory = modifiedUrl[1].replace(/\//g, '%2F');
        const modifiedPathname = decodeURIComponent(pathname).replace(
          modifiedUrl[1],
          modifiedCategory,
        );
        if (pathname !== modifiedPathname) {
          console.log('리다이렉트 경로:', modifiedPathname);
          navigate(modifiedPathname, {replace: true});
        }
      }
    }
  }, [location, navigate]);

  // 탐색 영역 전체에서 사용될 어드민 칩 메뉴 상태를 호출
  const {fetchCategoryMenu} = useDirectoryStore();
  useEffect(() => {
    fetchCategoryMenu();
  }, [fetchCategoryMenu]);

  return (
    <>
      <CustomRoutes>
        <Route path={ROUTE.DIRECTORY.CATEGORY.INDEX} element={<Directory />} />
        <Route
          path={ROUTE.DIRECTORY.CATEGORY._CATEGORY_MENU}
          element={<DirectoryCategory />}
        />
        <Route
          path={ROUTE.DIRECTORY.CATEGORY._CATEGORY_NAME._CATEGORY_TYPE}
          element={<DiscoverCategoryDetail />}
        />
      </CustomRoutes>
    </>
  );
};

export default DirectoryRoute;
